/**
 * Utilidades para validación y limpieza de números de teléfono
 */

/**
 * Permite solo números y caracteres especiales comunes en teléfonos
 * Caracteres permitidos: números (0-9), +, espacios, guiones, paréntesis
 */
export const handlePhoneInput = (e) => {
  const value = e.target.value;
  // Permitir solo números, +, espacios, guiones y paréntesis
  const cleaned = value.replace(/[^\d+\s\-()]/g, '');
  e.target.value = cleaned;
  return cleaned;
};

/**
 * Limpia el número de teléfono, dejando solo números y el signo + al inicio
 * Útil para guardar en la base de datos
 */
export const cleanPhoneNumber = (phone) => {
  if (!phone) return '';
  // Mantener el + si está al inicio, luego solo números
  const hasPlus = phone.trim().startsWith('+');
  const numbers = phone.replace(/\D/g, '');
  return hasPlus ? `+${numbers}` : numbers;
};

/**
 * Valida que el teléfono tenga un formato válido
 * Debe tener al menos 6 dígitos (después de limpiar)
 */
export const validatePhoneNumber = (phone) => {
  if (!phone || phone.trim() === '') return true; // Opcional, no requiere validación si está vacío
  const cleaned = cleanPhoneNumber(phone);
  const digitsOnly = cleaned.replace(/\D/g, '');
  return digitsOnly.length >= 6;
};

/**
 * Formatea el teléfono para mostrar (opcional, para mejor UX)
 * Ejemplo: +34 600 123 456
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  const cleaned = cleanPhoneNumber(phone);
  // Si tiene + al inicio, mantenerlo
  if (cleaned.startsWith('+')) {
    const countryCode = cleaned.substring(0, 3); // +34
    const rest = cleaned.substring(3).replace(/\D/g, '');
    if (rest.length >= 9) {
      return `${countryCode} ${rest.substring(0, 3)} ${rest.substring(3, 6)} ${rest.substring(6)}`;
    }
  }
  return cleaned;
};

